import { getCurrentUser, signIn } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { createAuthLogger } from "../utils/logger";

export const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      getCurrentUser()
        .then(() => {
          // Current user info retrieved
        })
        .catch(() => {
          // Auth error occurred
        });
    });

    const handleSignIn = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        
        try {
            // Attempting sign in
            const result = await signIn({ username, password });
            
            if (result.isSignedIn) {
                // Sign in successful - redirect to home page
                window.location.href = '/#/';
            } else {
                // Sign in returned but user not authenticated
                setError('Sign in failed - user not authenticated');
            }
        } catch (error) {
            const logger = createAuthLogger('signIn', undefined);
            logger.error('Sign in error', { error: error instanceof Error ? error.message : String(error) });
            setError(error instanceof Error ? error.message : 'Sign in failed');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <h2>Login</h2>
            <form onSubmit={handleSignIn}>
                <div>
                    <label htmlFor="username">Username:</label>
                    <input
                        id="username"
                        type="text"
                        value={username}
                        onChange={(e) => {
                            setUsername(e.target.value);
                            if (error) setError('');
                        }}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="password">Password:</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Signing In...' : 'Sign In'}
                </button>
            </form>
        </div>
    );
};